import React from "react";
import { Translate } from "react-auto-translate";
import { toast } from "react-toastify";
import { errorMessage } from "../actionMessages";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

// Some backend errors (e.g. Meta requiring a one-time Terms-of-Service
// acceptance) come with a direct link the user needs to click to fix things
// themselves. A plain-text toast that auto-closes in 2s isn't enough to act
// on -- linkify it into a real clickable <a> and leave the toast open until
// the user dismisses it.
function linkify(text) {
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "underline", fontWeight: 600 }}
      >
        {part}
      </a>
    ) : (
      part
    )
  );
}

function ToastAlert({ message, type, position = "TOP_RIGHT", autoClose = 2000 }) {
  if (sessionStorage.getItem("subscription_valid_status") < 0 && message === errorMessage) {
    return;
  }

  const hasLink = typeof message === "string" && URL_REGEX.test(message);
  URL_REGEX.lastIndex = 0; // URL_REGEX is a shared global-flag regex -- reset state after .test()

  const message_translated =
    typeof message === "string" && (hasLink ? <span>{linkify(message)}</span> : <Translate>{message}</Translate>);

  toast[type](message_translated, {
    position: toast.POSITION[position],
    autoClose: hasLink ? false : autoClose,
    hideProgressBar: false,
    theme: "colored",
    closeOnClick: !hasLink,
    pauseOnHover: true,
    draggable: true,
    pauseOnFocusLoss: false,
  });
}

export default ToastAlert;
